import { useContext, useState } from 'react'
import { FiLogOut } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AbsoluteContainer, Button, CustomContainer, GridContainer, SideBarContainer, SideBarShadow } from "src/style"
import { sideBarData } from './sidebar-data'
import { SidebarMenu } from './sidebar-menu'
import { DecisionBox } from 'src/component'
import { Features } from 'src/model'


export const Sidebar: React.FC = () => {
    const navigate = useNavigate()
    const {info: {institutionData} , logout} = useContext(AppInfoContext)
    const {visibility, showSideBar} = useContext(VisibilityContext)
    const [isDecisionBox, setIsDecisionBox] = useState(false)

    async function handleLogout () {
        await logout()
        navigate('/login')
    }

    return (
        <>
            <SideBarShadow isSideBar={visibility.isSideBar} onClick={() => showSideBar(false)}/>
            <SideBarContainer isSideBar={visibility.isSideBar}>
                <GridContainer minHeight='100' mnHUnit='%' className='y-scrollable-container' >
                    <CustomContainer bottomMargin='7'>
                        {
                            sideBarData.map((menu, index) => {
                                return (
                                    (
                                        (menu.title === 'Investment' && (!institutionData.featureIDs?.includes(Features.FIXED_DEPOSIT) && !institutionData.featureIDs?.includes(Features.TARGET_SAVINGS)))
                                        // || (menu.title === 'Borrow' && !institutionData.featureIDs?.includes(Features.RECOVA_LOAN))
                                    ) ?
                                        null
                                        : <SidebarMenu item={menu} key={index} />
                                )
                            })
                        }
                    </CustomContainer>

                    <AbsoluteContainer width='100' sizeUnit='%' bottom='3'>
                        <GridContainer>
                            <Button
                                width='4' height='4' radius='10'
                                hoverBgColor='#FB4E4E' hoverColor='#ffffff'
                                titleSize='2' bottomPadding='0.5'
                                onClick={() => setIsDecisionBox(true)}
                            >
                                <FiLogOut />
                            </Button>
                        </GridContainer>
                    </AbsoluteContainer>
                </GridContainer>
            </SideBarContainer>
            { isDecisionBox &&
                <DecisionBox 
                    yesBtnText='Yes, Logout'
                    noBtnTxt='No'
                    message='Are you sure you want to log out?'
                    height='22.5'
                    yesMethod={handleLogout}
                    close={() => setIsDecisionBox(false)} 
                />
            }
        </>
    )
}